import './PeriscopeV3PaginatedList.scss';
import { KeyPagination } from '@ui/KeyPagination';
import { PeriscopeList } from '.';
import { SonarRecord } from '@ui/records';
import React, { useCallback, useRef } from 'react';
export function PeriscopeV3PaginatedList({ loading, onChange, queryParams, renderListItem, resource }) {
    var _a, _b;
    const scrollableListRef = useRef(null);
    const renderList = useCallback((items) => items.map((item, childIndex) => {
        if (renderListItem) {
            return renderListItem(item, childIndex);
        }
        const castItem = item;
        return (React.createElement(SonarRecord, { key: castItem.sonarObjectId, name: castItem.displayName, sonarObjectId: castItem.sonarObjectId }));
    }), [renderListItem]);
    const results = (_a = resource === null || resource === void 0 ? void 0 : resource.results) !== null && _a !== void 0 ? _a : [];
    return (React.createElement(React.Fragment, null,
        React.createElement(PeriscopeList, { list: renderList, loading: loading, ref: scrollableListRef, results: results }),
        React.createElement(KeyPagination, { defaultPageSize: (_b = queryParams.count) !== null && _b !== void 0 ? _b : 20, listRef: scrollableListRef, onChange: onChange, resource: resource })));
}
